import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

export const adminConfig = [
  {
    title: "Tableau de bord",
    path: "/",
    icon: <img src="/assets/logo/home.svg" alt="home" />,
    iconHover: <img src="/assets/logo/home_white.svg" alt="home" />,
    references: ["/"],
    featureName: "dashboard",
    permissions: ["COACH", "OWNER", "ADMIN"],
  },
  {
    title: "",
    permissions: ["ADMIN"],
    featureName: "membres",
    children: [
      {
        title: "Clients",
        path: "/admin/clients",
        icon: <img src="/assets/logo/users.svg" alt="My Client" />,
        iconHover: <img src="/assets/logo/users_white.svg" alt="My Client" />,
        references: ["/admin/clients"],
        permissions: ["ADMIN"],
      },
    ],
  },
  {
    title: "Membres",
    permissions: ["COACH", "OWNER"],
    featureName: "membres",
    children: [
      {
        title: "Clients",
        path: "/clients",
        icon: <img src="/assets/logo/users.svg" alt="My Client" />,
        iconHover: <img src="/assets/logo/users_white.svg" alt="My Client" />,
        references: ["/clients"],
        permissions: ["COACH", "OWNER"],
      },
      {
        title: "Entraîneurs",
        path: "/coaches",
        icon: <img src="/assets/logo/coaches.svg" alt="Entraîneurs" />,
        iconHover: (
          <img src="/assets/logo/coaches_white.svg" alt="Entraîneurs" />
        ),
        references: ["/coaches"],
        permissions: ["OWNER"],
      },
    ],
  },
  {
    title: "Fitness",
    references: [
      "/fitness/exercices",
      "/fitness/sessions",
      "/fitness/programs",
    ],
    featureName: "fitness",
    permissions: ["COACH", "OWNER", "ADMIN"],
    children: [
      {
        title: "Exercices",
        path: "/fitness/exercices",
        icon: <img src="/assets/logo/exercices.svg" alt="Exercices" />,
        iconHover: (
          <img src="/assets/logo/exercices_white.svg" alt="Exercices" />
        ),
        references: [
          "/fitness/exercices/1",
          "/fitness/exercices",
          "/fitness/exercices/new",
        ],
        permissions: ["COACH", "OWNER", "ADMIN"],
      },
      {
        title: "Séances",
        path: "/fitness/sessions",
        icon: <img src="/assets/logo/sessions.svg" alt="Sessions" />,
        iconHover: <img src="/assets/logo/sessions_white.svg" alt="Sessions" />,
        references: [
          "/fitness/sessions/1",
          "/fitness/sessions",
          "/fitness/sessions/create",
        ],
        permissions: ["COACH", "OWNER", "ADMIN"],
      },
      {
        title: "Programmes",
        path: "/fitness/programs",
        icon: <img src="/assets/logo/programmes.svg" alt="Programmes" />,
        iconHover: (
          <img src="/assets/logo/programmes_white.svg" alt="Programmes" />
        ),
        references: [
          `/fitness/programs/1`,
          `/fitness/programs`,
          `/fitness/programs/final`,
          `/fitness/programs/create`,
        ],
        permissions: ["COACH", "OWNER", "ADMIN"],
      },
    ],
  },
  {
    title: "Nutrition",
    references: ["/nutrition/recipes", "/nutrition/programs"],
    permissions: ["COACH", "OWNER", "ADMIN"],
    featureName: "nutrition",
    children: [
      {
        title: "Recettes",
        path: "/nutrition/recipes",
        icon: <img src="/assets/logo/recipes.svg" alt="Recipes" />,
        iconHover: <img src="/assets/logo/recipes_white.svg" alt="Recipes" />,
        references: [
          "/nutrition/recipes/1",
          "/nutrition/recipes",
          "/nutrition/recipes/create",
        ],
        permissions: ["COACH", "OWNER", "ADMIN"],
      },
      {
        title: "Programmes",
        path: "/nutrition/programs",
        icon: (
          <img src="/assets/logo/recipe_programs.svg" alt="Recipes programs" />
        ),
        iconHover: (
          <img
            src="/assets/logo/recipe_programs_white.svg"
            alt="Recipes programs"
          />
        ),
        references: [
          "/nutrition/programs/create",
          "/nutrition/programs",
          "/nutrition/programs/final",
        ],
        permissions: ["COACH", "OWNER", "ADMIN"],
      },
    ],
  },
  {
    title: "Ressources",
    references: ["/tutoriels", "/ressources/personnalisation"],
    permissions: ["COACH", "OWNER", "ADMIN"],
    featureName: "marketing",
    children: [
      // {
      //   title: "Mon site marketing",
      //   path: "#",
      //   icon: <img src="/assets/logo/web.svg" alt="Web" />,
      //   iconHover: <img src="/assets/logo/web_white.svg" alt="Web" />,
      //   references: [],
      //   permissions: ["COACH", "OWNER"],
      // },
      {
        title: "Tutoriels",
        path: "/tutoriels",
        icon: <img src="/assets/logo/formations.svg" alt="Tutoriels" />,
        iconHover: <img src="/assets/logo/formations.svg" alt="Tutoriels" />,
        references: ["/tutoriels"],
        permissions: ["COACH", "OWNER", "ADMIN"],
        info: (
          <span style={{
            fontSize: "10px",
            fontWeight: 400,
            color: "#7B2FBE",
            border: "1px solid #7B2FBE",
            borderRadius: "4px",
            padding: "3px 5px",
            letterSpacing: "0.3px",
            whiteSpace: "nowrap",
            lineHeight: 1,
          }}>
            Nouveau
          </span>
        ),
      },
      {
        title: "À venir",
        path: null,
        icon: <AutoAwesomeIcon sx={{ fontSize: 18, color: "#4F5668" }} />,
        iconHover: <AutoAwesomeIcon sx={{ fontSize: 18, color: "#FFFFFF" }} />,
        references: [],
        permissions: ["COACH", "OWNER", "ADMIN"],
        isComingSoon: true,
        info: (
          <span style={{
            fontSize: "10px",
            fontWeight: 400,
            color: "#7B2FBE",
            border: "1px solid #7B2FBE",
            borderRadius: "4px",
            padding: "3px 5px",
            letterSpacing: "0.3px",
            whiteSpace: "nowrap",
            lineHeight: 1,
          }}>
            Nouveau
          </span>
        ),
      },
      {
        title: "Personnalisation",
        path: "/ressources/personnalisation",
        icon: <img src="/assets/logo/settings.svg" alt="Personnalisation" />,
        iconHover: <img src="/assets/logo/settings_white.svg" alt="Personnalisation" />,
        references: ["/ressources/personnalisation"],
        permissions: ["OWNER"],
      },
    ],
  },
  {
    title: "Support",
    references: [],
    permissions: ["COACH", "OWNER", "ADMIN"],
    featureName: "support",
    children: [
      // {
      //   title: "FAQ",
      //   path: "#",
      //   icon: <img src="/assets/logo/faq.svg" alt="FAQ" />,
      //   references: [],
      //   permissions: ["COACH", "OWNER"],
      // },
      {
        title: "Paramètres",
        path: "/settings",
        icon: <img src="/assets/logo/settings.svg" alt="Settings" />,
        iconHover: <img src="/assets/logo/settings_white.svg" alt="Settings" />,
        references: [],
        permissions: ["COACH", "OWNER", "ADMIN"],
      },
    ],
  },
];
